import { Injectable } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { Event, NavigationEnd, Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
const MOBILE_VIEW = 'screen and (max-width: 768px)';
@Injectable({ providedIn: 'root' })
export class NavService {
    private sidenav: MatSidenav;
    public currentUrl = new BehaviorSubject<any>(undefined);
    
    constructor(private router: Router) {
        this.router.events.subscribe((event: Event) => {
            if (event instanceof NavigationEnd) {
                this.currentUrl.next(event.urlAfterRedirects);
            }
        });
       
    }
    setSidenav(sidenav: MatSidenav) {
        this.sidenav = sidenav;
      }
    
      closeSidenav() {
        if (this.sidenav && window.matchMedia(MOBILE_VIEW).matches) {
            console.log('Closing sidenav for mobile view');
            this.sidenav.close();
        } else {
            console.log('Sidenav close skipped (not mobile view or sidenav undefined)');
        }
    }



}
